export default __webpack_public_path__ + "static/02-03-writing-spelling-feedback-71e8af40cdb6269bb3d272413efdfa13.mp4";